import { render, staticRenderFns } from "./latest_invoice.vue?vue&type=template&id=b70e401a&scoped=true&"
import script from "./latest_invoice.vue?vue&type=script&lang=js&"
export * from "./latest_invoice.vue?vue&type=script&lang=js&"
import style0 from "./latest_invoice.vue?vue&type=style&index=0&id=b70e401a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70e401a",
  null
  
)

export default component.exports